
















































































































import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component
export default class ConversationInfo extends Vue {
    constructor() {
        super();
    }

    get conversation() {
        return this.$store.getters['Messages/activeConversation'];
    }

    get property() {
        if (this.conversation === null || this.conversation.propertyId === null) {
            return null;
        }

        return this.$store.getters['Properties/getProperty'](this.conversation.propertyId);
    }

    get getUserId() {
        return this.$store.getters['User/getUserId'];
    }

    get projectName() {
        if (this.conversation === null) {
            return null;
        }
        const property = this.property;
        const building = this.$store.getters['Buildings/getBuilding'](property.buildingId);
        if (typeof building === 'undefined') {
            return null;
        }
        const project = this.$store.getters['Projects/getProject'](building.projectId);
        if (typeof project === 'undefined') {
            return null;
        }
        return project.name;
    }

    public participantData(id: number, key: any) {
        const participant =  this.$store.getters['User/getCacheUser'](id);
        if (key === 'fullName') {
            return `${participant.firstName} ${participant.familyName}`;
        } else if (key === 'firstInitial') {
            return  participant.firstName.charAt(0);
        }
        return participant[key];
    }

    public participantImage(id: any) {
        const participant =  this.$store.getters['User/getCacheUser'](id);

        if (!participant.fetchedMiniature) {
            participant.fetchMiniature(this.$store);
            participant.fetchedMiniature = true;
        }

        if (participant.hasMiniature || participant.hasProfileImage) {
            if (participant.hasMiniature) {
                return participant.miniatureImage;
            }

            if (participant.hasProfileImage) {
                return participant.profileImage;
            }
        }

        return null;
    }

    get rent() {
        if (this.property === null) {
            return '';
        }

        return this.property.rentAmount + ' ' + this.property.rentCurrency;
    }

    get deposit() {
        if (this.property === null) {
            return '';
        }

        return this.property.depositAmount + ' ' + this.property.depositCurrency;
    }

    public changeConversationTitle() {
        this.$store.dispatch(Actions.CHANGE_CONVERSATION_TITLE, {title: this.conversation.title, id: this.conversation.id});
    }

    public openCreateTicketForm() {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_VISIBILITY, true);
    }

}
